<mat-card appearance="outlined" class="mat-elevation-z8">
    
    <div class="container">
        <div class="header"> {{'certificates.certificateHistory' | translate}}</div>
        <div class="columns-info">
            <div class="row-info">
                <span class="bold"> {{'certificates.serialNumberTable' | translate}}:</span>
                <span>{{rowData.serialNumber}}</span>
            </div>
            <div class="row-info">
                <span class="bold"> {{'certificates.nameOfClientTable' | translate}}:</span>
                <span>{{rowData.clientName}}</span>
            </div>
            <div class="row-info">
                <span class="bold"> {{'certificates.clientIdentification' | translate}}:</span>
                <span>{{rowData.clientIdentification}}</span>
            </div>
        </div>
        <div class="action-buttons">
            <button mat-button type="button" class="mat-mdc-raised-button"
                routerLink="/business/hardwareCertificates" [state]="{ fromCertificateHistory: true }">{{'common.back' | translate }}</button>
            <button mat-button (click)="exportExcel()" type="button" class="mat-mdc-raised-button">{{
                'certificates.exportExcel' | translate }}</button>
        </div>
        <div class="spinner-container" *ngIf="loading">
            <mat-spinner class="content-box"></mat-spinner>
        </div>
        <div class="table-container" *ngIf="!loading">
            <div class="mat-elevation-z8 table-content">
                <div class="table-scroll-wrapper">
                    <mat-table [dataSource]="certificateHistory" class="mat-table-wrapper">
                        <ng-container matColumnDef="requestNumber">
                            <mat-header-cell *matHeaderCellDef>
                                {{ 'certificates.requestNumber' | translate }}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{ element.requestNumber }} </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="requestDate">
                            <mat-header-cell *matHeaderCellDef>
                                {{ 'certificates.requestDate' | translate }}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{element.requestDate}}
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="confirmationDate">
                            <mat-header-cell *matHeaderCellDef>
                                {{ 'certificates.confirmationDate' | translate }}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element">{{ element.confirmationDate | date: 'short'}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="type">
                            <mat-header-cell *matHeaderCellDef>
                                {{ 'certificates.actionType' | translate }}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element">{{ element.type }}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="requestStatus">
                            <mat-header-cell *matHeaderCellDef>
                                {{ 'certificates.requestStatus' | translate }}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                {{element.requestStatus}}
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="appliedCRL">
                            <mat-header-cell *matHeaderCellDef>
                                {{ 'certificates.appliedCRL' | translate }}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                {{element.appliedCRL}}
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="crlAppliedDate">
                            <mat-header-cell *matHeaderCellDef>
                                {{ 'certificates.crlAppliedDate' | translate }}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                {{element.crlAppliedDate}}
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="validFrom">
                            <mat-header-cell *matHeaderCellDef>
                                {{ 'certificates.validFrom' | translate }}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                {{element.validFrom }}
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="validTo">
                            <mat-header-cell *matHeaderCellDef>
                                {{ 'certificates.validTo' | translate }}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                {{element.validTo }}
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="publicAccess">
                            <mat-header-cell *matHeaderCellDef>
                                {{ 'certificates.publicAccess' | translate }}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                {{element.publicAccess}}
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="agent">
                            <mat-header-cell *matHeaderCellDef>
                                {{ 'certificates.agent' | translate }}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                {{element.agent}}
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="agentOffice">
                            <mat-header-cell *matHeaderCellDef>
                                {{ 'certificates.agentOffice' | translate }}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                {{element.agentOffice}}
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="requestCreatorFullName">
                            <mat-header-cell #agent_office *matHeaderCellDef="let requestCreatorFullName">
                                {{'certificates.requestCreatorFullName' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let row">
                                <div class="cell " [ngClass]="row.requestCreatorFullName !== null ? 'show' : 'hide'">
                                    {{row.requestCreatorFullName}}
                                </div>
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="requestCreatorCompany">
                            <mat-header-cell #agent_office *matHeaderCellDef="let requestCreatorCompany">
                                {{'certificates.requestCreatorCompany' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let row">
                                <div class="cell " [ngClass]="row.requestCreatorCompany !== null ? 'show' : 'hide'">
                                    {{row.requestCreatorCompany}}
                                </div>
                            </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                    </mat-table>
                </div>
            </div>
        </div>
    </div>
</mat-card>